<template>
  <v-radio-group
    v-model="value"
    :label="label"
    :persistent-hint="typeof hint !== 'undefined'"
    :hint="hint"
    :disabled="disabled"
    @change="$emit('update:inputData', {
      value: $event,
      item: parseOptions(params.options).find(item => item.value === value)
    })"
    :rules="rules"
    :row="$vuetify.breakpoint.mdAndUp && params.orientation === 'horizontal'"
  >
    <v-radio
      v-for="(option) in parseOptions(params.options)"
      :key="`entry-${option.id}`"
      :label="option.label"
      :value="option.value"
    ></v-radio>

  </v-radio-group>
</template>

<script>
export default {
  props: {
    label: String,
    hint: String,
    placeholder: String,
    disabled: Boolean,
    initialValue: {
      required: false,
    },
    inputData: Object,
    rules: {
      type: Array,
      default: () => [],
    },
    params: {
      type: Object,
      default: () => ({}),
    },
  },
  data({ initialValue }) {
    return {
      value: initialValue,
    };
  },
  created() {
    const { options } = this.params;

    if (Object.keys(options).length < 2) {
      throw new Error(`input group need at least two options (got ${ Object.keys(options.length) })`);
    }
  },
  methods: {
    parseOptions(options = {}) {
      return Object.entries(options)
        .map((entry) => ({
          ...entry[1],
          // if value is not provided we will use as value the item label
          value: entry[1].value || entry[1].label,
          id: entry[0],
        }));
    },
  },
  beforeDestroy() {
    this.$emit('update:inputData', {});
  },
};
</script>

<style lang="scss">

.v-input--radio-group--column .v-input--radio-group__input > .v-label {
  margin-bottom: 8px;
}

</style>
